import React from "react";
import { Fab, Box, Fade, useScrollTrigger } from "@mui/material";
import RocketIcon from '@mui/icons-material/Rocket';


interface Props {
  window?: () => Window;
  children?: React.ReactElement<unknown>;
}

const ScrollTop=(props: Props)=> {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const anchor = (
      (event.target as HTMLDivElement).ownerDocument || document
    ).querySelector('#header');

    if (anchor) {
      anchor.scrollIntoView({
        block: 'center',
        behavior:'smooth'
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: 'fixed', bottom: 70, right: 64 }}
      >
        {children}
      </Box>
    </Fade>
  );
}



const ScrollToTop = (props:Props)=> {
    return (
      <ScrollTop {...props}>
        <Fab size="large" aria-label="scroll back to top" color={'primary'}>
          <RocketIcon />
        </Fab>
      </ScrollTop>
    );
  }
  
  export default ScrollToTop;